import { Certificado } from './../../models/cetificado.model';
import { Component, ViewChild, Renderer } from '@angular/core';
import { NavController, NavParams, Platform, MenuController, ModalController } from 'ionic-angular';
import { CustomAlert } from '../../components/custom-alert.component';
import { Storage } from '@ionic/storage';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'
import { InAppBrowser } from '@ionic-native/in-app-browser';
//Pages
import { AulasPage } from '../aulas/aulas';
import { PalestrantesPage } from '../palestrantes/palestrantes';
import { TabsPage } from '../tabs/tabs';
import { BuscaPage } from '../busca/busca';
import { AtividadePage } from '../atividade/atividade';
import { PalestrantePerfilPage } from '../palestrante-perfil/palestrante-perfil';
import { ExpositorVideoPage } from '../expositor-video/expositor-video';
//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { CongressoProvider } from '../../providers/congresso-provider';
import { SearchProvider } from '../../providers/search-provider';
import { GeralProvider } from '../../providers/geral-provider';
import { UserProvider } from '../../providers/user-provider';
import { StorageProvider } from '../../providers/storage-provider';
import { AuthProvider } from './../../providers/auth-provider';
//Models
import { Url } from '../../models/url.model';
import { User } from '../../models/user.model';
import { Congresso } from '../../models/congresso.model';
import { Lecturer } from '../../models/lecturer.model';
import { Banner } from '../../models/banner.model';
import { BannerItem } from '../../models/banner-item.model';
import { Activity } from '../../models/activity.model';
import { Expositor } from '../../models/expositor/expositor.model';
import { ExpositorProvider } from '../../providers/expositor-provider';

@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})

export class HomePage {

    isDesktop: boolean;

    public user: User;
    public congresso: Congresso;
    public isCurrent: boolean;
    public banner: Banner;
    public bannersPatrocinados: Array<BannerItem>;
    public bannersConteudo: Array<BannerItem>;
    public loaded = false;
    public congressos: Array<Congresso>;
    public activities: Array<Activity>;
    public lastRefreshDate: string;
    public isConected: boolean;
    public expositores: Array<Expositor>;
    public organizacao: Expositor;
    public splash = false;

    constructor(
        public navCtrl: NavController,
        private menuCtrl: MenuController,
        private alert: CustomAlert,
        private configProvider: ConfigProvider,
        private utilProvider: UtilProvider,
        private userProvider: UserProvider,
        private auth: AuthProvider,
        private searchProvider: SearchProvider,
        private storageProvider: StorageProvider,
        private navParams: NavParams,
        private congressoProvider: CongressoProvider,
        private geralProvider: GeralProvider,
        private expositorProvider: ExpositorProvider,
        public platform: Platform,
        private sanitizer: DomSanitizer,
        private iab: InAppBrowser,
        private modalCtrl: ModalController) {

        this.congressos = JSON.parse(localStorage.getItem('congressos')) as Array<Congresso>;
        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        this.isCurrent = this.congresso.Ano == configProvider.ANO_ATUAL || this.congresso.Liberado;
        this.banner = new Banner();
        this.bannersConteudo = new Array<BannerItem>();
        this.bannersPatrocinados = new Array<BannerItem>();
        this.activities = new Array<Activity>();
        this.expositores = new Array<Expositor>();
    }

    ionViewDidEnter() {
        this.menuCtrl.swipeEnable(true, 'right');
        this.utilProvider.searchInFocus = false;
        this.utilProvider.searchTerm = "";
        this.lastRefreshDate = this.storageProvider.get('lastRefreshDate');
        localStorage.setItem('firstAccess', 'false');


        this.getBanner();
        this.getExpositores()
    }


    ionViewDidLoad() {

        if (this.utilProvider.isConnected(false)) {


            if (this.congresso.Ano == this.congressos[0].Ano)
                this.getProgramacaoAtual();

            this.loadStorageForUser();
        }
    }

    checkIsDesktopView() {
        setTimeout(() => {
            this.utilProvider.isDesktopView().subscribe(isDesktop => {
                this.isDesktop = isDesktop;
                if (this.isDesktop) {
                    let elem = <HTMLElement>document.querySelector(".header-img");
                    if (elem != null) {
                        elem.style.display = 'none';
                    }
                }
            });
        }, 0);
    }

    getProgramacaoAtual() {

        let self = this;

        if (!self.lastRefreshDate || self.utilProvider.checkTimeToRefresh(self.lastRefreshDate)) {
            let connected = self.utilProvider.isConnected(false);
            if (connected) {
                let user = new User();

                //self.utilProvider.loadingShow()

                self.congressoProvider.getCompleteProgramNoRealTime(self.congressos[0].Ano, user.Guid, user.TipoAssociacao, user.CategoriaId)
                    .then(res => {

                        res.forEach(x => {
                            Array.prototype.push.apply(self.activities, x.Atividades);
                        });

                        self.storageProvider.set('programacaoAtual', res);

                        if (self.congresso.Ano == self.congressos[0].Ano) {
                            if (self.congresso.IsOnline)
                                self.storageProvider.set('atividadesArea', res)
                            else
                                self.storageProvider.set('atividadesDia', res)

                            let lastRefreshDate = new Date().toISOString();
                            self.storageProvider.set('lastRefreshDate', lastRefreshDate);
                        }
                        //self.utilProvider.loadingHide();
                    })
                    .catch(response => {
                        if (connected) {
                            let err = response;
                            if (err) {

                                self.alert.showAlert('Erro', 'Ocorreu um erro interno ao tentar recuperar a programação atual.');
                            }
                        }
                        //self.utilProvider.loadingHide();

                    });
            }
        }
    }


    loadStorageForUser() {
        if (localStorage.getItem('user')) {
            let user = JSON.parse(localStorage.getItem('user')) as User;
            let self = this;
            let connected = self.utilProvider.isConnected(false)
            if (connected) {
                self.userProvider.getAtividadesInscritasIdsUsuario(user.Guid, self.congressos[0].Ano)
                    .then(d => {

                        if (d)
                            localStorage.setItem('atividadesInscritas', JSON.stringify(d))
                    });

                self.userProvider.getPalestrantesFavoritos(user.Guid, self.congressos[0].Ano)
                    .then(r => {

                        if (r)
                            localStorage.setItem('palestrantesFavoritos', JSON.stringify(r.resposta.retorno))
                    });

                self.userProvider.getAtividadesAssistidasIdsUsuario(user.Guid, self.congressos[0].Ano)
                    .then(d => {

                        if (d)
                            localStorage.setItem('atividadesAssistidas', JSON.stringify(d))
                    });

            }
        }
    }

    getBanner() {
        let self = this;
        setTimeout(() => {
            let connected = self.utilProvider.isConnected(true);

            if (connected) {
                self.geralProvider.getBanners(this.congresso.Ano)
                    .then(res => {
                        self.banner = res as Banner;
                        if (self.banner.BannerItem) {
                            if (self.banner.BannerItem.filter(x => !x.IsPatrocinado)) {
                                self.bannersConteudo = self.banner.BannerItem.filter(x => !x.IsPatrocinado) as Array<BannerItem>;
                                self.bannersConteudo.forEach(x => {
                                    x.Image = this.sanitizer.bypassSecurityTrustStyle('url(' + x.ImagemUrlNovoApc + ')');
                                });
                            }
                            if (self.banner.BannerItem.filter(x => x.IsPatrocinado)) {
                                self.bannersPatrocinados = self.banner.BannerItem.filter(x => x.IsPatrocinado) as Array<BannerItem>;

                                self.bannersPatrocinados.forEach(x => {
                                    x.Image = this.sanitizer.bypassSecurityTrustStyle('url(' + x.ImagemUrlNovoApc + ')');
                                });
                            }
                        }

                        self.loaded = true;
                        this.checkIsDesktopView();
                    })
                    .catch(response => {
                        if (connected) {
                            let err = response;
                            if (err) {
                                self.alert.showAlert('Erro', 'Ocorreu um erro ao recuperar informações do congresso.');
                            }
                        }
                        self.loaded = true;
                    });

            }
            else {
                self.loaded = true;
            }
        }, 0);
    }

    getExpositores() {
        let self = this;
        setTimeout(() => {
            let connected = self.utilProvider.isConnected(true);

            if (connected) {

                self.expositorProvider.getExpositores(this.congresso.Ano, true, true)
                    .then(res => {

                        res as Array<Expositor>;

                        let _organizacao = res.filter(function (x) { return x.Tipo == 'Organização'; });

                        if (_organizacao[0]) {
                            this.organizacao = _organizacao[0];
                            this.organizacao.LogoImage = this.sanitizer.bypassSecurityTrustStyle('url(' + self.configProvider.url.Cientifico + _organizacao[0].Logo + ')');
                        }

                        self.expositores = [];
                        let _expositores = res.filter(function (x) { return x.Tipo == 'Patrocínio'; })

                        _expositores.forEach(x => {
                            x.LogoImage = this.sanitizer.bypassSecurityTrustStyle('url(' + self.configProvider.url.Cientifico + x.Logo + ')');
                            self.expositores.push(x);
                        });
                    })
                    .catch(response => {
                        if (connected) {
                            let err = response;
                            if (err) {
                                self.alert.showAlert('Erro', 'Ocorreu um erro ao recuperar informações do congresso.');
                            }
                        }
                    });
            }
        }, 0);
    }

    openUrl(url, inNativeBrowser) {
        if (this.utilProvider.isNullOrEmpty(url) || url == '#')
            return false;

        if (inNativeBrowser) {

            const browser = this.iab.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
            browser.show();

        } else {
            const browser = this.iab.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
            browser.show();
        }
    }

    getCertificado() {
        let self = this;
        if (this.utilProvider.isConnected(true) && this.auth.isAuthorized()) {
            let user = JSON.parse(localStorage.getItem('user')) as User;

            let model = new Certificado();
            model.EventoId = 0;
            model.EventoAno = this.congresso.Ano;
            model.UsuarioId = user.SgunId;
            model.IsCna = false;

            self.utilProvider.loadingShow();

            self.userProvider.getCertificado(model)
                .then(res => {
                    self.utilProvider.loadingHide();
                 
                    if (res) {

                        let data = JSON.parse(res);
                        if (data.resposta.codigo == 0) {

                            this.openUrl(data.resposta.retorno, false);
                        }
                        else {
                            this.alert.showAlert("Erro", data.resposta.retorno);
                        }
                    }
                });
        }
    }

    onLink(url: string) {
        window.open(url);
    }

    goto(page: string, param: string) {

        if (page) {
            page = page.toLocaleLowerCase()
            if ((page == 'atividade' || page == 'aulas' || page == 'Aula') && param) {
                this.navCtrl.push(AtividadePage, { id: param })
            }
            else if (page == 'aulas' || page == '1') {
                this.navCtrl.setRoot(TabsPage, { id: 1 });
                this.navCtrl.parent.select(0);
            }
            else if (page == 'agenda' || page == '2') {
                this.navCtrl.setRoot(TabsPage, { id: 2 });
                this.navCtrl.parent.select(2);
            }
            else if ((page == 'palestranteperfil' || page == 'palestrantes' || page == 'palestrante') && param) {
                this.navCtrl.setRoot(PalestrantePerfilPage, { id: param })
            }
            else if (page == 'palestrantes' || page == '3') {
                this.navCtrl.setRoot(TabsPage, { id: 3 });
                this.navCtrl.parent.select(1);
            }
            else if (page == 'expositores' || page == '4') {
                this.navCtrl.setRoot(TabsPage, { id: 3 });
                this.navCtrl.parent.select(3);
            }
            else if (page == 'video') {
                if (this.utilProvider.isConnected(true)) {
                    let modal = this.modalCtrl.create(ExpositorVideoPage, {
                        id: this.banner.Id,
                        urlVideo: param,
                        titlePage: 'SOGESP'
                    });
                    modal.present();
                }
            }
            else if (page == 'link') {
                this.openUrl(param, false);
            }
        }
    }

    goToTab(tabId: number) {
        this.navCtrl.setRoot(TabsPage, { id: tabId, tabIndex: tabId });
    }

    hasResult() {
        return this.bannersConteudo && this.bannersConteudo.length != 0;
    }

    goToAulas() {
        this.navCtrl.push(TabsPage, { id: 1 });
        this.navCtrl.parent.select(1);
    }

    goToPalestrantes() {
        this.navCtrl.push(TabsPage, { id: 3 });
        this.navCtrl.parent.select(3);
    }

    downloadProgramacao() {

        let self = this;

        // var link = document.createElement('a');
        // link.href = `${self.configProvider.url.Cientifico}/shared/apc/files/programacoes-cientificas/programacao-cientifica-${self.congresso.Ano}.pdf`;
        // link.target="blank";
        // link.download = 'Programação Científica ' + this.congresso.Ano;
        // link.dispatchEvent(new MouseEvent('click'));

        self.openUrl('https://dv.sogesp.com.br/congresso/2020/programacao', false);
    }

    onInput(term: any) {
        let user = JSON.parse(localStorage.getItem('user')) as User;
        this.navCtrl.push(BuscaPage, { 'term': term.target.value });
    }

    onCancel(term: any) {

    }

    hasPatrocinado() {
        return this.bannersPatrocinados.length != 0;
    }

    getHeightContent(bool: boolean) {
        return this.utilProvider.getPlatform() == 'ios' ? 'h-70' : 'h-70';
    }

    getHeightContent100(bool: boolean) {
        return this.utilProvider.getPlatform() == 'ios' ? 'h-100-ios' : 'h-100-ios';
    }

    getHeightBanner() {
        return this.utilProvider.getPlatform() == 'ios' ? 'h-25' : 'h-26';
    }

    closeApp() {
        let self = this;
        self.platform.exitApp();
    }

    toggleMenu() {
        this.menuCtrl.toggle();
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts